module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/pc/search_result_page/profile_image-326e3bd964fe2759f00a0cbd2987ab7b.png";